import React from "react";
import Image from "components/image";
import { Swiper, SwiperSlide } from "components/swiper";
import { useSelector } from "react-redux";
import SwiperCore, { Navigation, Pagination, Mousewheel } from "swiper";

SwiperCore.use([Pagination, Navigation, Mousewheel]);

const Skeleton = () => (
	<div className="w-full h-[57.5vh] md:h-[80vh] bg-gray-200 animate-pulse" />
);

const BundleCuratorGallery = ({ images }) => {
	if (!images?.length) return null;
	const { isClient } = useSelector(state => state.global);

	const settings = {
		modules: [Pagination],
		slidesPerView: 1, preventClicks: true, preventClicksPropagation: false, freeMode: true, spaceBetween: 10,
		mousewheel: { enabled: true, forceToAxis: true },
		slidesPerGroup: 1,
		navigation: { enabled: true, nextEl: ".right-arrow-pb", prevEl: ".left-arrow-pb" },
		pagination: { clickable: true, el: ".swiper-pagination", type: "bullets" },
		a11y: true,
	};

	return (
		<div className="lg:w-11/12 lg:mx-auto">
			<Swiper {...settings} skeleton={Skeleton} showLoader>
				{images?.map((i) => (
					<SwiperSlide key={i._key}>
						<Image image={i.asset} />
					</SwiperSlide>
				))}
			</Swiper>
			{isClient && <div className="swiper-pagination" />}
		</div>
	);
};

export default BundleCuratorGallery;